import {
  ListResponse,
  HttpClient,
  BaseGetAllFilter,
  BaseReadApi,
  baseReadApiFactory,
} from '@amzn/dots-core-ui';
import { Plan, PlanItem } from '../models';

export type PlanId = Plan['id'];

export interface PlanGetAllFilter extends BaseGetAllFilter<PlanId> {
  ids?: number[];
  name?: string;
  page?: number;
  pageSize?: number;
}

export interface PlanApi extends BaseReadApi<PlanId, Plan, PlanGetAllFilter>{
  create: (plan: Partial<Plan>) => Promise<Plan>;
  update: (id: number, plan: Partial<Plan>) => Promise<Plan>;
  getItems: (id: number) => Promise<ListResponse<PlanItem>>;
  addItem: (planId: number, item: Partial<PlanItem>) => Promise<PlanItem>;
  updateItem: (planId: number, item: Partial<PlanItem>) => Promise<PlanItem>;
  removeItem: (planId: number, itemId: number) => Promise<undefined>;
}

export const plans = (client: HttpClient): PlanApi => ({
  ...baseReadApiFactory(client, 'plan'),
  create: (plan: Partial<Plan>): Promise<Plan> =>
    client.post({ url: '/plan', payload: plan }),
  update: (id: number, plan: Partial<Plan>): Promise<Plan> =>
    client.put({
      url: `/plan/${id}`,
      payload: {
        ...plan,
        id,
      },
    }),
  getItems: (id: number): Promise<ListResponse<PlanItem>> =>
    client.get({ url: `/plan/${id}/item`, payload: { page: 0, pageSize: 0 } }),
  addItem: (planId: number, item: Partial<PlanItem>): Promise<PlanItem> =>
    client.post({ url: `/plan/${planId}/item`, payload: { ...item, planId } }),
  updateItem: (planId: number, item: Partial<PlanItem>): Promise<PlanItem> =>
    client.post({
      url: `/plan/${planId}/item/${item.id}`,
      payload: { planId, ...item },
    }),
  removeItem: (planId: number, itemId: number): Promise<undefined> =>
    client.delete({ url: `/plan/${planId}/item/${itemId}` }),
});
